import createComponent from 'styles/fela/createComponent';

export const StyledCheckbox = createComponent(({ theme, checked, focused }) => ({
  border: '2px solid',
  borderColor: theme.color.primary,
  borderRadius: '2px',
  cursor: 'pointer',
  height: '1.5rem',
  width: '1.5rem',
  transition: 'background-color 100ms linear, border-color 100ms linear',
  flexShrink: '0',
  extend: [
    {
      condition: checked,
      style: {
        backgroundColor: theme.color.brand,
        borderColor: theme.color.brand,
        color: theme.color.brandIconColor,
      },
    },
    {
      condition: focused,
      style: {
        boxShadow: `0 0 0 2px ${theme.color.primary}`,
      },
    },
  ],
}), 'div', ['checked', 'focused']);

export const HiddenInput = createComponent(() => ({
  position: 'absolute',
  opacity: 0,
  cursor: 'pointer',
  height: 0,
  width: 0,
}), 'input');

export const Wrapper = createComponent(() => ({
  textAlign: 'left',
  width: '100%',
}));
